import './Alert.scss'

import React, { Component } from 'react'
import cx from 'bem-classnames';

class Alert extends Component {

    render() {
        let classes = {
            name: 'Alert',
            modifiers: ['type']
        }
        
        var alert = (<div className={cx(classes, this.props)}>
          { this.props.errorText }
        </div>)

        return this.props.errorText !== "" ? alert : null
    }
}

export default Alert